import { createPathFromRoute } from 'assets/utils/dom/UrlParsing';
import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Request = Api.Core.Contract.ChangeCreator.IRequest;
type Response = Api.Core.Contract.ChangeCreator.IResponse;
type Headers = Api.Core.Contract.ChangeCreator.IHeaders;
const url = '/api/Sales/Contract/ChangeCreator/:contractId/:creatorId';
export default async function contractChangeCreatorApi(params: Request): Promise<Api.Res<Response>> {
  return await executeServerApi<Request, Response, Headers>({
    method: HttpMethod.put,
    url: createPathFromRoute(url, params, null),
    headers: getDefaultHeaders(),
  });
}
